// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE BASE */
.about-section {
  background: linear-gradient(180deg, #425151 0%, #1e2a2a 100%);
  color: #FFE600;
  text-align: center;
  min-height: 100vh;
  padding: clamp(50px, 8vw, 80px) 20px;
  font-family: "Poppins", Arial, sans-serif;
}

.about-container {
  max-width: 1100px;
  margin: 0 auto;
}


/* HEADING */
.about-title {
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 500;
  color: #FFE600;
  margin-bottom: 10px;
}


/* CARD COMPONENTS */
.about-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: clamp(18px, 3vw, 28px) clamp(16px, 3vw, 30px);
  margin: 25px auto;
  max-width: 800px;
  backdrop-filter: blur(10px);
}

.about-card-title {
  color: #FFE600;
  font-size: clamp(1.1rem, 1.8vw, 1.3rem);
  font-weight: 500;
  margin-bottom: 10px;
}

.about-card-text {
  color: #ffffff;
  font-size: clamp(0.9rem, 1.4vw, 1rem);
  line-height: 1.65;
}


/* TAGLINE */
.about-highlight {
  margin: clamp(30px, 6vw, 60px) 0;
  font-size: clamp(1.2rem, 2.5vw, 1.6rem);
  font-weight: 500;
  color: #FFE600;
}


/* TEAM TITLE */
.team-title {
  font-size: clamp(1.4rem, 3vw, 1.8rem);
  font-weight: 500;
  color: #ffffff;
  margin-bottom: clamp(25px, 4vw, 40px);
  margin-top: clamp(40px, 6vw, 60px);
}


/* ===============================
   TEAM GRID — 3 per row desktop
=============================== */
.team-grid-modern {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  width: 100%;
}


/* ===============================
   IMAGE WRAPPER — uniform size
=============================== */
.team-modern-image-box {
  width: 100%;
  height: 340px;               /* fixed: SAME size for every image */
  border-radius: 18px;
  background: #223030;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;            /* keeps clean shape */
}


/* ===============================
   IMAGE — centered & cropped equally
=============================== */
.team-modern-image {
  width: 100%;
  height: 100%;
  object-fit: cover;           /* same visual size */
  object-position: 50% 30%;    
  border-radius: 18px;
  transition: 0.3s ease;
  filter: grayscale(20%);
}

.team-modern-item:hover .team-modern-image {
  filter: grayscale(0%);
  transform: scale(1.03);
}


/* TEAM MEMBER TEXT */
.team-modern-item {
  text-align: center;
}

.team-modern-name {
  font-size: clamp(1rem, 1.6vw, 1.15rem);
  font-weight: 500;
  color: #ffffff;
  margin-top: 12px;
}

.team-modern-company {
  color: #FFE600;
  font-size: clamp(0.8rem, 1.4vw, 0.95rem);
  margin-top: 4px;
}

.team-modern-role {
  color: #d8d8d8;
  font-size: clamp(0.75rem, 1.3vw, 0.85rem);
  margin-top: 2px;
}


/* ===============================
      RESPONSIVE BREAKPOINTS
=============================== */

/* Tablet — 2 per row */
@media (max-width: 992px) {
  .team-grid-modern {
    grid-template-columns: repeat(2, 1fr);
  }

  .team-modern-image-box {
    height: 300px;
  }
}

/* Mobile — 1 per row */
@media (max-width: 600px) {
  .team-grid-modern {
    grid-template-columns: 1fr;
  }

  .team-modern-image-box {
    height: 250px;
  }

  /* On mobile show full image, do not crop heads */
  .team-modern-image {
    object-fit: contain;
    background: #2d3a3a;
    padding: 10px;
  }

  .about-section {
    padding: 50px 15px;
  }
}


/* ===============================
   LARGE SCREEN SUPPORT
=============================== */

/* Large desktop (1440px) */
@media (min-width: 1440px) {
  .team-grid-modern {
    gap: 50px;
  }

  .team-modern-image-box {
    height: 380px;
  }

  .team-modern-name {
    font-size: 1.25rem;
  }
}

/* 2K screens (1920px) */
@media (min-width: 1920px) {
  .team-modern-image-box {
    height: 420px;
  }
}

/* 4K screens (2560px) */
@media (min-width: 2560px) {
  .team-grid-modern {
    gap: 70px;
    max-width: 2000px;
    margin: 0 auto;
  }

  .team-modern-image-box {
    height: 480px;
  }

  .team-modern-name {
    font-size: 1.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/ABOUTUS/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA,YAAY;AACZ;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;;AAGA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,sDAAsD;EACtD,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB;;;AAGA,YAAY;AACZ;EACE,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;;;AAGA,eAAe;AACf;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,kCAAkC;AACpC;;;AAGA;;iCAEiC;AACjC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;;AAGA;;iCAEiC;AACjC;EACE,WAAW;EACX,aAAa,gBAAgB,qCAAqC;EAClE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,aAAa,sBAAsB;AACrD;;;AAGA;;iCAEiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,YAAY,qBAAqB;EAClD,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;;AAGA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;;;AAGA;;iCAEiC;;AAEjC,uBAAuB;AACvB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA,iDAAiD;EACjD;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;iCAEiC;;AAEjC,2BAA2B;AAC3B;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* PAGE BASE */\n.about-section {\n  background: linear-gradient(180deg, #425151 0%, #1e2a2a 100%);\n  color: #FFE600;\n  text-align: center;\n  min-height: 100vh;\n  padding: clamp(50px, 8vw, 80px) 20px;\n  font-family: \"Poppins\", Arial, sans-serif;\n}\n\n.about-container {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n\n/* HEADING */\n.about-title {\n  font-size: clamp(2rem, 4vw, 3.2rem);\n  font-weight: 500;\n  color: #FFE600;\n  margin-bottom: 10px;\n}\n\n\n/* CARD COMPONENTS */\n.about-card {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: clamp(18px, 3vw, 28px) clamp(16px, 3vw, 30px);\n  margin: 25px auto;\n  max-width: 800px;\n  backdrop-filter: blur(10px);\n}\n\n.about-card-title {\n  color: #FFE600;\n  font-size: clamp(1.1rem, 1.8vw, 1.3rem);\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.about-card-text {\n  color: #ffffff;\n  font-size: clamp(0.9rem, 1.4vw, 1rem);\n  line-height: 1.65;\n}\n\n\n/* TAGLINE */\n.about-highlight {\n  margin: clamp(30px, 6vw, 60px) 0;\n  font-size: clamp(1.2rem, 2.5vw, 1.6rem);\n  font-weight: 500;\n  color: #FFE600;\n}\n\n\n/* TEAM TITLE */\n.team-title {\n  font-size: clamp(1.4rem, 3vw, 1.8rem);\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: clamp(25px, 4vw, 40px);\n  margin-top: clamp(40px, 6vw, 60px);\n}\n\n\n/* ===============================\n   TEAM GRID — 3 per row desktop\n=============================== */\n.team-grid-modern {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  width: 100%;\n}\n\n\n/* ===============================\n   IMAGE WRAPPER — uniform size\n=============================== */\n.team-modern-image-box {\n  width: 100%;\n  height: 340px;               /* fixed: SAME size for every image */\n  border-radius: 18px;\n  background: #223030;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;            /* keeps clean shape */\n}\n\n\n/* ===============================\n   IMAGE — centered & cropped equally\n=============================== */\n.team-modern-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;           /* same visual size */\n  object-position: 50% 30%;    \n  border-radius: 18px;\n  transition: 0.3s ease;\n  filter: grayscale(20%);\n}\n\n.team-modern-item:hover .team-modern-image {\n  filter: grayscale(0%);\n  transform: scale(1.03);\n}\n\n\n/* TEAM MEMBER TEXT */\n.team-modern-item {\n  text-align: center;\n}\n\n.team-modern-name {\n  font-size: clamp(1rem, 1.6vw, 1.15rem);\n  font-weight: 500;\n  color: #ffffff;\n  margin-top: 12px;\n}\n\n.team-modern-company {\n  color: #FFE600;\n  font-size: clamp(0.8rem, 1.4vw, 0.95rem);\n  margin-top: 4px;\n}\n\n.team-modern-role {\n  color: #d8d8d8;\n  font-size: clamp(0.75rem, 1.3vw, 0.85rem);\n  margin-top: 2px;\n}\n\n\n/* ===============================\n      RESPONSIVE BREAKPOINTS\n=============================== */\n\n/* Tablet — 2 per row */\n@media (max-width: 992px) {\n  .team-grid-modern {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .team-modern-image-box {\n    height: 300px;\n  }\n}\n\n/* Mobile — 1 per row */\n@media (max-width: 600px) {\n  .team-grid-modern {\n    grid-template-columns: 1fr;\n  }\n\n  .team-modern-image-box {\n    height: 250px;\n  }\n\n  /* On mobile show full image, do not crop heads */\n  .team-modern-image {\n    object-fit: contain;\n    background: #2d3a3a;\n    padding: 10px;\n  }\n\n  .about-section {\n    padding: 50px 15px;\n  }\n}\n\n\n/* ===============================\n   LARGE SCREEN SUPPORT\n=============================== */\n\n/* Large desktop (1440px) */\n@media (min-width: 1440px) {\n  .team-grid-modern {\n    gap: 50px;\n  }\n\n  .team-modern-image-box {\n    height: 380px;\n  }\n\n  .team-modern-name {\n    font-size: 1.25rem;\n  }\n}\n\n/* 2K screens (1920px) */\n@media (min-width: 1920px) {\n  .team-modern-image-box {\n    height: 420px;\n  }\n}\n\n/* 4K screens (2560px) */\n@media (min-width: 2560px) {\n  .team-grid-modern {\n    gap: 70px;\n    max-width: 2000px;\n    margin: 0 auto;\n  }\n\n  .team-modern-image-box {\n    height: 480px;\n  }\n\n  .team-modern-name {\n    font-size: 1.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
